let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("cdke4")).then(() => parcelRequire('kwqIJ'));